import apiClient from "./client";
import {
  startSession,
  getSession,
  autosave,
  submitSession,
  findInProgressSession,
} from "./sessions";
import type { Answer, ExamContent, Session } from "@/types";

/**
 * Reading API.
 * Content: GET /reading/tests/{test_id}
 * Sessions use the shared /sessions endpoints with skill="reading".
 */

const SKILL = "reading" as const;

export async function getReadingExam(testId: number): Promise<ExamContent> {
  const { data } = await apiClient.get<ExamContent>(
    `/reading/tests/${testId}`
  );
  return data;
}

export const startReading = (testId: number): Promise<Session> =>
  startSession({ test_id: testId, skill: SKILL });

export const getReadingSession = (sessionId: number): Promise<Session> =>
  getSession(sessionId);

export const findReadingSession = (testId: number): Promise<Session | null> =>
  findInProgressSession(testId, SKILL);

export const saveReadingAnswers = (
  sessionId: number,
  answers: Answer[]
): Promise<Session> => autosave(sessionId, answers);

export const submitReading = (
  sessionId: number,
  answers: Answer[]
): Promise<Session> => submitSession(sessionId, { answers });
